<template>
  <el-card class="mat12 media_row_card approval_card" v-if="type==item.handState ">
    <div class="header_title">
      <span class="weight">
        {{item.userName}}：
        <span class="argen" :class="{red:item.state==2}">{{item | handleState}}</span>
      </span>
      <span class="time"> / {{item.createDate}}</span>
    </div>
    <p class="desc" v-if="item.message">监交人意见：{{item.message}}</p>
    <p class="desc" v-if="item.remark">备注：{{item.remark}}</p>
  </el-card>
</template>

<script>
export default {
  name: "CardBriefApprovla", // 审批信息
  props: ["item", "type", "isurgent"], // type区分是审批还是交接的
  filters: {
    handleState: function(value) {
      let state = value.state;
      let handState = value.handState;
      if (handState == 0) {
        switch (state) {
          case 1:
            return "同意离职";
          case 2:
            return "已驳回";
        }
      } else {
        switch (state) {
          case 1:
            return "监交无误";
          case 2:
            return "交接异常";
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.approval_card {
  .header_title {
    line-height: 40px;
    .weight {
      font-weight: bold;
      color: #333;
    }
    .argen {
      color: #333;
      font-weight: 400;
    }
    .time {
      color: #333;
      font-weight: 400;
    }
    .color_blue {
      color: #409eff;
    }
  }
  .desc {
    line-height: 24px;
  }
}

.red {
  color: #ff0000 !important;
}
</style>